
import Vue from 'vue'
import InsuranceCard from '../insurance-card/index.vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  name: 'InsuranceCardList',
  components: {
    InsuranceCard
  },
  mixins: [staticBlockMixin]
})
